import { refreshCrmProfilePhonePause } from '@/shared/auth/auth.reducer';
import { isProfileAcwActive } from '@/shared/model/phone-pause';
/** PBX may set `isPhonePause` shortly after BYE — stagger profile GETs. */
const ACW_PROFILE_RETRY_DELAYS_MS = [0, 800, 2000, 4000];
let syncInFlight = false;
/**
 * Refetch `GET /api/users/profile` after a voice session ends so toolbar ACW matches
 * `isPhonePause` / `phonePauseEnd` from the PBX. Shared lock avoids duplicate bursts.
 */
export async function syncAcwProfileAfterHangup(dispatch) {
    if (syncInFlight)
        return null;
    syncInFlight = true;
    try {
        let profile = null;
        for (const delayMs of ACW_PROFILE_RETRY_DELAYS_MS) {
            if (delayMs > 0) {
                await new Promise((resolve) => window.setTimeout(resolve, delayMs));
            }
            try {
                profile = await dispatch(refreshCrmProfilePhonePause()).unwrap();
            }
            catch {
                profile = null;
            }
            if (profile && isProfileAcwActive(profile)) {
                return profile;
            }
        }
        return profile;
    }
    finally {
        syncInFlight = false;
    }
}
